import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import urls, { relativeUrl } from '@/constants/urls';

const TokensOption = ({ allowTokens }) => {
  if (!allowTokens) {
    return null;
  }

  return (
    <>
      <Dropdown.Divider />
      <Dropdown.Item
        title=""
        as="a"
        href={`#${relativeUrl(urls.MY_TOKENS)}`}
        selected={false}
        className="aridhia-tokens-option"
      >
        <Icon name="code" />
        <FormattedMessage id="header.my.tokens" />
      </Dropdown.Item>
      <Dropdown.Divider />
    </>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { users } } },
}) => ({ allowTokens: users.token_read });

export default connect(mapStateToProps)(TokensOption);
